import React from 'react';
import { useThemedValueSwitch } from '@tq/ui-components';

import { TqAppFooter } from './components/TqAppFooter';
import { NiAppFooter } from './components/NiAppFooter';

export const AppFooter: React.FC = () => {
  const { isTQ } = useThemedValueSwitch();

  return isTQ ? <TqAppFooter /> : <NiAppFooter />;
};
